const LINKED_STORE_CARD_PREFIX = "LinkedStoreCard";

export const LINKED_STORE_CARD_CLASSES = {
  button: `${LINKED_STORE_CARD_PREFIX}-button`,
  buttonLabel: `${LINKED_STORE_CARD_PREFIX}-buttonLabel`,
  storeCard: `${LINKED_STORE_CARD_PREFIX}-storeCard`,
};
